// extracted by mini-css-extract-plugin
export default {"addToCartControl":"gZ-z","giftCard":"hZ-z","btnContainer":"iZ-z","cartButton":"jZ-z","disabled":"kZ-z"};